import * as React from "react"
import { ECSenzSiteApp } from "./ECSenzSite/ECSenzSiteApp"
import "@fontsource/inter"
import { setServicePath } from "@core-frontend/Core/Frontend"
import { implementFrontend } from "@core-frontend/Core/implementFrontend"

require("../html/style.css")

const ecstorePath = "api/ecstore/v1/"
const authenticationServerPath = "api/authentication/v2/"

setServicePath("ecstore", ecstorePath)
setServicePath("authentication", authenticationServerPath)

implementFrontend("ecsenzstore", {}, async _finalStyle => {
    return <ECSenzSiteApp />
})

// TODO: I have special requirments or configuration, contact me
// TODO: I have ordered before, please use the same settings as the previous order
// TODO: Show sensor specifications
// TODO: Visa toleranser i grafer?
